import React from 'react';
import './servicioBotonFlotante.css';
const BotonFlotanteServicios = ({ onClick }) => {
  return (
    <>
      
      <div className="texto-flotante" onClick={onClick}>
        Pon tu servicio
      </div>
    </>
  );
};

export default BotonFlotanteServicios;
///crear-perfil-negocio